import { render } from "./edit-car.vue?vue&type=template&id=6c36d715"
import script from "./edit-car.vue?vue&type=script&lang=js"
export * from "./edit-car.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__